module.exports = __webpack_public_path__ + "gw.c70b84b8cd1629b6fad7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gw.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gw.svg
// module chunks = styles